import type { Tagged } from 'type-fest';
import { InvalidDomainIdError } from '../invalidDomainIdError';

export type MongoId = Tagged<string, 'MongoId'>;
export namespace MongoId {
  export const FromString = (id: string): MongoId => {
    if (!/^[0-9A-Za-z]{24}$/.test(id)) {
      throw new InvalidDomainIdError();
    }
    return id as MongoId;
  };
}
